import type { App } from 'vue';
import { Button } from './Button';
import {
  Input,
  Layout,
  Select,
  AutoComplete,
  Switch,
  InputNumber,
  Table,
  Steps,
  Form,
  Row,
  Col,
  Modal,
} from 'ant-design-vue';
import Vue3ColorPicker from 'vue3-colorpicker';
import vue3TreeOrg from 'vue3-tree-org'; // 树形结构组件
import kuka from './kuka';
export function registerGlobComp(app: App) {
  // app.use(Input).use(Button).use(Layout);
  app
    .use(Select)
    .use(AutoComplete)
    .use(InputNumber)
    .use(Switch)
    .use(Input)
    .use(Button)
    .use(Layout)
    .use(Table)
    .use(Steps)
    .use(Form)
    .use(Row)
    .use(Col)
    .use(Modal)
    .use(vue3TreeOrg)
    .use(Vue3ColorPicker)
    .use(kuka);
}
